import { combineReducers } from "@reduxjs/toolkit";
import jobsData from "./jobsData";
import { RouterState } from "redux-first-history";
import userData from "./userData";
import emailDataPages from "./emailDataPageSlice";
import controlCenterData from "./controlCenterData";
import systemData from "./systemData";
import shipment from "./shipmentSlice";
import admin from "./adminSlice";

// Define the root reducer function
const createRootReducer = (
  routerReducer: (state: RouterState | undefined, action: any) => RouterState
) =>
  combineReducers({
    jobsData,
    userData,
    emailDataPages,
    controlCenterData,
    systemData,
    shipment,
    admin,
    router: routerReducer, // Use the router reducer from store.ts
  });

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;

export default createRootReducer;
